import React from "react";
import { Redirect, Route, Switch } from "react-router";

const MainLayout = React.lazy(()=>import('../layouts/Main'))
function Routes() {
    return ( 
        <React.Suspense fallback={null} >
            <Switch>
                <Route exact path='/'>
                    <Redirect to='/admin' />
                </Route>
                <Route path='/user' render={(props)=><MainLayout {...props}/>} />
                <Route path='/admin' render={(props)=><MainLayout {...props}/>} />
                <Route path='/session' render={(props)=><MainLayout {...props}/>} />
                <Route path='*'>
                    <Redirect to="/user" />
                </Route>
            </Switch>
        </React.Suspense>
     );
}

export default Routes;